import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import servicePeople from 'services/people';

/**
 * @typedef {Object} UseRemovePanelistFromPanelMutationVariables
 * @property {number} personId
 * @property {number} panelId
 */

/** @typedef {Omit<UseMutationOptions<any, Error, UseRemovePanelistFromPanelMutationVariables, unknown>, 'mutationKey' | 'mutationFn'>} UseRemovePanelistFromPanelMutationOptions */

/**
 * Mutation hook for removing a panelist from a panel.
 *
 * @param {UseRemovePanelistFromPanelMutationOptions} [options={}]
 */
export const useRemovePanelistFromPanelMutation = (options = {}) => {
    return useMutation({
        ...options,
        mutationKey: ['remove-panelist-from-panel'],
        /** @param {UseRemovePanelistFromPanelMutationVariables} variables */
        mutationFn: ({ personId, panelId }) => servicePeople.removePanelistFromPanel(personId, panelId)
    });
};
